var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.svgClass,attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.iconName,"width":"1em","height":"1em"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }